// src/components/legal-content/legal-content.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment FileLinkFragment on EGDSStandardLink {\n    text\n    action {\n      ... on UILinkAction {\n        resource {\n          ... on URI {\n            value\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSHeadingFragment on EGDSHeading {\n    headingType\n    egdsElementId\n    text\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    text\n    action {\n      target\n      resource {\n        value\n      }\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    weight\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSInlineLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSParagraphFragment\n    ...EGDSPlainTextFragment\n    ...EGDSSpannableTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment LevelListFragment on LevelOneList {\n    type\n    items {\n      text {\n        ...EGDSTextFragment\n      }\n      children {\n        type\n        items {\n          text {\n            ...EGDSTextFragment\n          }\n          children {\n            type\n            items {\n              text {\n                ...EGDSTextFragment\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSOrderedListFragment on EGDSOrderedList {\n    items {\n      ...EGDSTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextIconListItemFragment on EGDSTextIconListItem {\n    icon {\n      id\n      title\n      description\n    }\n    text\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextIconListFragment on EGDSTextIconList {\n    listItems {\n      ...EGDSTextIconListItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUnorderedListFragment on EGDSUnorderedList {\n    items {\n      ...EGDSTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextListFragment on EGDSTextList {\n    ...EGDSUnorderedListFragment\n    ...EGDSOrderedListFragment\n    ...EGDSTextIconListFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment PortableTextWithLinkTableFragment on PortableTextWithLink {\n    portableTextContent {\n      ...EGDSTextFragment\n      ...EGDSTextListFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment TableSectionFragment on PortableTextHTMLTableSection {\n    rows {\n      ... on SectionRow {\n        rowContent {\n          ...PortableTextWithLinkTableFragment\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment PortableTextContentFragment on portableTextContent {\n    ...EGDSPlainTextFragment\n    ...EGDSHeadingFragment\n    ...EGDSSpannableTextFragment\n    ...TableSectionFragment\n    ...EGDSInlineLinkFragment\n    ...EGDSStylizedTextFragment\n    ...LevelListFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment LegalDocumentFragment on PortableTextWithLink {\n    fileLink {\n      ...FileLinkFragment\n    }\n    portableTextContent {\n      ...PortableTextContentFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  query LegalContentQuery(\n    $context: ContextInput!\n    $uriContext: UriContextInput\n    $contentTopic: String!\n    $preview: Boolean\n    $requestDate: String\n    $egPlatformURL: String\n  ) {\n    travelExperienceManagerContent(\n      context: $context\n      uriContext: $uriContext\n      contentTopic: $contentTopic\n      preview: $preview\n      requestDate: $requestDate\n      egPlatformURL: $egPlatformURL\n    ) {\n      portableTextDocumentWithLink {\n        ...LegalDocumentFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
import React20 from "react";
import { gql as gql20, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/legal-content/__private/__fragments/legal-document.tsx
import React19 from "react";
import { gql as gql19 } from "@apollo/client";
// src/components/legal-content/__private/__fragments/file-link.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkLink } from "uitk-react-link";
var fragment = gql(_templateObject());
var FileLink = function(param) {
    var _param_data = param.data, text = _param_data.text, action = _param_data.action;
    return /* @__PURE__ */ React.createElement(UitkLink, null, /* @__PURE__ */ React.createElement("a", {
        href: action.resource.value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, text));
};
FileLink.fragment = fragment;
FileLink.displayName = "FileLink";
// src/components/legal-content/__private/__fragments/portable-text-content.tsx
import { gql as gql18 } from "@apollo/client";
// ../internal/src/components/egds-list/egds-level-list.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkList, UitkListItem } from "uitk-react-list";
// ../internal/src/components/egds-text/egds-text.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-heading.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var fragment2 = gql2(_templateObject1());
var _obj;
var EGDSHeadingStyleMap = (_obj = {}, _define_property(_obj, "H1" /* H1 */ , "h1"), _define_property(_obj, "H2" /* H2 */ , "h2"), _define_property(_obj, "H3" /* H3 */ , "h3"), _define_property(_obj, "H4" /* H4 */ , "h4"), _define_property(_obj, "H5" /* H5 */ , "h5"), _define_property(_obj, "H6" /* H6 */ , "h6"), _define_property(_obj, "H7" /* H7 */ , "h6"), _define_property(_obj, "H8" /* H8 */ , "h6"), _obj);
var _obj1;
var EGDSHeadingSizeMap = (_obj1 = {}, _define_property(_obj1, "H1" /* H1 */ , 2), _define_property(_obj1, "H2" /* H2 */ , 4), _define_property(_obj1, "H3" /* H3 */ , 5), _define_property(_obj1, "H4" /* H4 */ , 6), _define_property(_obj1, "H5" /* H5 */ , 7), _define_property(_obj1, "H6" /* H6 */ , 8), _define_property(_obj1, "H7" /* H7 */ , 8), _define_property(_obj1, "H8" /* H8 */ , 8), _obj1);
var EGDSHeading = function(param) {
    var data = param.data, size = param.size;
    var tag = data.headingType !== null ? EGDSHeadingStyleMap[data.headingType] : void 0;
    var headingSize = (size !== null && size !== void 0 ? size : data.headingType == null) ? void 0 : EGDSHeadingSizeMap[data.headingType];
    var elementId = data.egdsElementId !== null ? data.egdsElementId : void 0;
    return /* @__PURE__ */ React2.createElement(UitkHeading, {
        tag: tag,
        size: headingSize,
        id: elementId
    }, data.text);
};
EGDSHeading.fragment = fragment2;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment3 = gql3(_templateObject2());
var _obj2;
var EGDSParagraphSizeMap = (_obj2 = {}, _define_property(_obj2, "P1" /* P1 */ , 1), _define_property(_obj2, "P2" /* P2 */ , 2), _define_property(_obj2, "P3" /* P3 */ , 3), _obj2);
var EGDSParagraph = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React3.createElement(UitkParagraph, {
        size: EGDSParagraphSizeMap[data.style]
    }, data.text);
};
EGDSParagraph.fragment = fragment3;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var fragment4 = gql4(_templateObject3());
var EGDSPlainText = function(param) {
    var data = param.data, align = param.align, weight = param.weight, size = param.size, _param_theme = param.theme, theme = _param_theme === void 0 ? "default" : _param_theme;
    return /* @__PURE__ */ React4.createElement(UitkText, {
        whiteSpace: "pre-line",
        inline: true,
        align: align,
        weight: weight,
        size: size,
        theme: theme
    }, data.text);
};
EGDSPlainText.fragment = fragment4;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkLink as UitkLink2 } from "uitk-react-link";
var fragment5 = gql5(_templateObject4());
var EGDSInlineLink = function(param) {
    var data = param.data, inline = param.inline, linkSize = param.linkSize, _param_target = param.target, target = _param_target === void 0 ? "_self" : _param_target;
    return /* @__PURE__ */ React5.createElement(UitkLink2, {
        size: linkSize,
        inline: inline
    }, /* @__PURE__ */ React5.createElement("a", {
        href: data.action.resource.value,
        target: target,
        rel: "noopener noreferrer"
    }, data.text));
};
EGDSInlineLink.fragment = fragment5;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment6 = gql6(_templateObject5());
var _obj3;
var UitkTextWeightMap = Object.freeze((_obj3 = {}, _define_property(_obj3, "BOLD" /* BOLD */ , "bold"), _define_property(_obj3, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj3, "REGULAR" /* REGULAR */ , "regular"), _obj3));
var EGDSStylizedText = function(param) {
    var data = param.data, inline = param.inline, size = param.size, _param_theme = param.theme, theme = _param_theme === void 0 ? "default" : _param_theme;
    return /* @__PURE__ */ React6.createElement(UitkText2, {
        weight: data.weight ? UitkTextWeightMap[data.weight] : void 0,
        inline: inline,
        size: size,
        theme: theme
    }, data.text);
};
EGDSStylizedText.fragment = fragment6;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment7 = gql7(_templateObject6(), EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSInlineLink.fragment);
var EGDSSpannableTextContent = function(param) {
    var data = param.data, align = param.align, weight = param.weight, linkSize = param.linkSize, textSize = param.textSize, target = param.target, theme = param.theme;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React7.createElement(EGDSPlainText, {
                data: data,
                weight: weight,
                size: textSize,
                align: align,
                theme: theme
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React7.createElement(EGDSStylizedText, {
                data: data,
                inline: true,
                size: textSize,
                theme: theme
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React7.createElement(EGDSInlineLink, {
                data: data,
                inline: true,
                linkSize: linkSize,
                target: target
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment7;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment8 = gql8(_templateObject7(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(param) {
    var data = param.data, weight = param.weight, textSize = param.textSize, linkSize = param.linkSize, target = param.target, theme = param.theme;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, data.contents.map(function(content, index) {
        return /* @__PURE__ */ React8.createElement(EGDSSpannableTextContent, {
            data: content,
            key: index,
            weight: weight,
            textSize: textSize,
            linkSize: linkSize,
            target: target,
            theme: theme
        });
    }));
};
EGDSSpannableText.fragment = fragment8;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment9 = gql9(_templateObject8(), EGDSParagraph.fragment, EGDSPlainText.fragment, EGDSHeading.fragment, EGDSSpannableText.fragment);
var EGDSText = function(param) {
    var data = param.data, align = param.align, weight = param.weight, textSize = param.textSize, linkSize = param.linkSize, target = param.target;
    switch(data.__typename){
        case "EGDSHeading":
            return /* @__PURE__ */ React9.createElement(EGDSHeading, {
                data: data
            });
        case "EGDSParagraph":
            return /* @__PURE__ */ React9.createElement(EGDSParagraph, {
                data: data
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React9.createElement(EGDSPlainText, {
                data: data,
                size: textSize,
                align: align
            });
        case "EGDSSpannableText":
            return /* @__PURE__ */ React9.createElement(EGDSSpannableText, {
                data: data,
                linkSize: linkSize,
                textSize: textSize,
                weight: weight,
                target: target
            });
        default:
            return null;
    }
};
EGDSText.fragment = fragment9;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/egds-list/egds-level-list.tsx
var fragment10 = gql10(_templateObject9(), EGDSText.fragment);
var constructList = function(listItems, listProps, target) {
    if (!listItems || listItems && !listItems.length) {
        return null;
    }
    return /* @__PURE__ */ React10.createElement(UitkList, _object_spread({}, listProps), listItems.map(function(listItem, listIndex) {
        var _listItem_children;
        return /* @__PURE__ */ React10.createElement(UitkListItem, {
            key: listIndex
        }, /* @__PURE__ */ React10.createElement(EGDSText, {
            data: listItem.text,
            target: target
        }), ((_listItem_children = listItem.children) === null || _listItem_children === void 0 ? void 0 : _listItem_children.items) && constructList(listItem.children.items, listProps, target));
    }));
};
var LevelList = function(param) {
    var _param_data = param.data, items = _param_data.items, type = _param_data.type, className = param.className, size = param.size, spacing = param.spacing, target = param.target;
    var listProps = {
        className: className,
        size: size,
        spacing: spacing,
        bullet: type === "NUMBER" ? "tiered-numbered" : "default",
        type: type === "NUMBER" ? "ordered" : "unordered",
        indent: type !== "NUMBER"
    };
    if (!items || items && !items.length) {
        return null;
    }
    return constructList(items, listProps, target);
};
LevelList.fragment = fragment10;
LevelList.displayName = "LevelList";
// src/components/legal-content/__private/__fragments/legal-text.tsx
import React18 from "react";
// ../internal/src/components/egds-list/egds-text-list.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
// ../internal/src/components/egds-list/egds-ordered-list.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkList as UitkList2, UitkListItem as UitkListItem2 } from "uitk-react-list";
var fragment11 = gql11(_templateObject10(), EGDSText.fragment);
var EGDSOrderedList = function(param) {
    var data = param.data, className = param.className, listProps = param.listProps, weight = param.weight, textSize = param.textSize, linkSize = param.linkSize;
    var items = data.items;
    if (!items || items && !items.length) {
        return null;
    }
    return /* @__PURE__ */ React11.createElement(UitkList2, _object_spread_props(_object_spread({}, listProps), {
        className: className,
        type: "ordered"
    }), items.map(function(item, index) {
        return /* @__PURE__ */ React11.createElement(UitkListItem2, {
            key: index
        }, /* @__PURE__ */ React11.createElement(EGDSText, {
            data: item,
            weight: weight,
            textSize: textSize,
            linkSize: linkSize
        }));
    }));
};
EGDSOrderedList.fragment = fragment11;
EGDSOrderedList.displayName = "EGDSOrderedList";
// ../internal/src/components/egds-list/egds-text-icon-list.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkList as UitkList3 } from "uitk-react-list";
// ../internal/src/components/egds-list/egds-text-icon-list-item.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkIcon } from "uitk-react-icons";
import { UitkListItem as UitkListItem3 } from "uitk-react-list";
var fragment12 = gql12(_templateObject11());
var EGDSTextIconListItem = function(param) {
    var data = param.data;
    var icon = data.icon, text = data.text;
    return /* @__PURE__ */ React12.createElement(UitkListItem3, null, /* @__PURE__ */ React12.createElement(UitkIcon, {
        id: icon.id,
        name: icon.id,
        title: icon.title || "",
        description: icon.description || ""
    }), text);
};
EGDSTextIconListItem.fragment = fragment12;
EGDSTextIconListItem.displayName = "EGDSTextIconListItem";
// ../internal/src/components/egds-list/egds-text-icon-list.tsx
var fragment13 = gql13(_templateObject12(), EGDSTextIconListItem.fragment);
var EGDSTextIconList = function(param) {
    var listItems = param.data.listItems, className = param.className, size = param.size, spacing = param.spacing, bullet = param.bullet;
    var listProps = {
        className: className,
        size: size,
        spacing: spacing,
        bullet: bullet !== null && bullet !== void 0 ? bullet : "icon-alternate"
    };
    if (!listItems.length) {
        return null;
    }
    return /* @__PURE__ */ React13.createElement(UitkList3, _object_spread({}, listProps), listItems.map(function(item, index) {
        return /* @__PURE__ */ React13.createElement(EGDSTextIconListItem, {
            key: index,
            data: item
        });
    }));
};
EGDSTextIconList.fragment = fragment13;
EGDSTextIconList.displayName = "EGDSTextIconList";
// ../internal/src/components/egds-list/egds-unordered-list.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkList as UitkList4, UitkListItem as UitkListItem4 } from "uitk-react-list";
var fragment14 = gql14(_templateObject13(), EGDSText.fragment);
var EGDSUnorderedList = function(param) {
    var data = param.data, className = param.className, listProps = param.listProps, weight = param.weight, textSize = param.textSize, linkSize = param.linkSize;
    var items = data.items;
    if (!items || items && !items.length) {
        return null;
    }
    return /* @__PURE__ */ React14.createElement(UitkList4, _object_spread_props(_object_spread({}, listProps), {
        className: className,
        type: "unordered"
    }), items.map(function(item, index) {
        return /* @__PURE__ */ React14.createElement(UitkListItem4, {
            key: index
        }, /* @__PURE__ */ React14.createElement(EGDSText, {
            data: item,
            weight: weight,
            textSize: textSize,
            linkSize: linkSize
        }));
    }));
};
EGDSUnorderedList.fragment = fragment14;
EGDSUnorderedList.displayName = "EGDSUnorderedList";
// ../internal/src/components/egds-list/egds-text-list.tsx
var fragment15 = gql15(_templateObject14(), EGDSUnorderedList.fragment, EGDSOrderedList.fragment, EGDSTextIconList.fragment);
var ListTypesMap = {
    EGDSOrderedList: EGDSOrderedList,
    EGDSUnorderedList: EGDSUnorderedList,
    EGDSTextIconList: EGDSTextIconList
};
var EGDSTextList = function(param) {
    var className = param.className, size = param.size, spacing = param.spacing, type = param.type, data = param.data;
    var listProps = {
        className: className,
        size: size,
        spacing: spacing,
        type: type
    };
    var ListType = ListTypesMap[data.__typename];
    if (!ListType) {
        return null;
    }
    return /* @__PURE__ */ React15.createElement(ListType, _object_spread_props(_object_spread({}, listProps), {
        data: data
    }));
};
EGDSTextList.fragment = fragment15;
EGDSTextList.displayName = "EGDSTextList";
// src/components/legal-content/__private/__fragments/legal-text.tsx
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// src/components/legal-content/__private/__fragments/portable-text-table-section.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkTable, UitkTableBody, UitkTableCell, UitkTableCellBorder, UitkTableHead, UitkTableRow } from "uitk-react-tables";
// src/components/legal-content/__private/__fragments/portable-text-with-link-table.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
var fragment16 = gql16(_templateObject15(), EGDSText.fragment, EGDSTextList.fragment);
var PortableTextWithLinkTable = function(param) {
    var portableTextContent = param.data.portableTextContent, weight = param.weight;
    return /* @__PURE__ */ React16.createElement(React16.Fragment, null, portableTextContent.map(function(element, index) {
        return legalText(element, {
            weight: weight,
            spacing: false,
            textSize: 300,
            key: "PortableTextHTMLTableSection-CellItem-".concat(index)
        });
    }));
};
PortableTextWithLinkTable.fragment = fragment16;
PortableTextWithLinkTable.displayName = "PortableTextWithLinkTable";
// src/components/legal-content/__private/__fragments/portable-text-table-section.tsx
var fragment17 = gql17(_templateObject16(), PortableTextWithLinkTable.fragment);
var TableSection = function(param) {
    var rows = param.data.rows;
    var _rows__rowContent, _rows_, _rows, _rows_slice, _rows1;
    return /* @__PURE__ */ React17.createElement(UitkSpacing, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React17.createElement(UitkTable, null, /* @__PURE__ */ React17.createElement(UitkTableHead, null, /* @__PURE__ */ React17.createElement(UitkTableRow, null, (_rows = rows) === null || _rows === void 0 ? void 0 : (_rows_ = _rows[0]) === null || _rows_ === void 0 ? void 0 : (_rows__rowContent = _rows_.rowContent) === null || _rows__rowContent === void 0 ? void 0 : _rows__rowContent.map(function(element, index) {
        return /* @__PURE__ */ React17.createElement(UitkTableCell, {
            key: index,
            border: UitkTableCellBorder.horizontal,
            align: {
                horizontal: "leading",
                vertical: "top"
            }
        }, element && /* @__PURE__ */ React17.createElement(PortableTextWithLinkTable, {
            data: element,
            weight: "bold"
        }));
    }))), /* @__PURE__ */ React17.createElement(UitkTableBody, null, (_rows1 = rows) === null || _rows1 === void 0 ? void 0 : (_rows_slice = _rows1.slice(1)) === null || _rows_slice === void 0 ? void 0 : _rows_slice.map(function(row, index) {
        var _row_rowContent, _row;
        return /* @__PURE__ */ React17.createElement(UitkTableRow, {
            key: index
        }, (_row = row) === null || _row === void 0 ? void 0 : (_row_rowContent = _row.rowContent) === null || _row_rowContent === void 0 ? void 0 : _row_rowContent.map(function(element, elementIndex) {
            return /* @__PURE__ */ React17.createElement(UitkTableCell, {
                key: elementIndex,
                border: UitkTableCellBorder.horizontal,
                align: {
                    vertical: "top"
                }
            }, element && /* @__PURE__ */ React17.createElement(PortableTextWithLinkTable, {
                data: element,
                weight: "regular"
            }));
        }));
    }))));
};
TableSection.fragment = fragment17;
TableSection.displayName = "TableSectionFragment";
// src/components/legal-content/__private/__fragments/legal-text.tsx
var legalText = function(data, param) {
    var textSize = param.textSize, spacing = param.spacing, weight = param.weight, key = param.key;
    var linkSize = "large";
    var linkTarget = "_self";
    var blockstart;
    var component;
    switch(data.__typename){
        case "EGDSPlainText":
            component = /* @__PURE__ */ React18.createElement(EGDSPlainText, {
                data: data,
                size: textSize,
                weight: weight,
                key: key
            });
            break;
        case "EGDSHeading":
            {
                component = /* @__PURE__ */ React18.createElement(EGDSHeading, {
                    data: data
                });
                blockstart = "four";
                break;
            }
        case "EGDSSpannableText":
            component = /* @__PURE__ */ React18.createElement("div", null, /* @__PURE__ */ React18.createElement(EGDSSpannableText, {
                data: data,
                linkSize: linkSize,
                textSize: textSize,
                target: linkTarget,
                weight: weight,
                key: key
            }));
            break;
        case "EGDSOrderedList":
            component = /* @__PURE__ */ React18.createElement(EGDSOrderedList, {
                data: data,
                linkSize: linkSize,
                textSize: textSize,
                key: key
            });
            break;
        case "EGDSUnorderedList":
            component = /* @__PURE__ */ React18.createElement(EGDSUnorderedList, {
                data: data,
                linkSize: linkSize,
                textSize: textSize,
                key: key
            });
            break;
        case "LevelOneList":
            component = /* @__PURE__ */ React18.createElement(LevelList, {
                data: data,
                target: linkTarget,
                key: key
            });
            break;
        case "EGDSInlineLink":
            component = /* @__PURE__ */ React18.createElement(EGDSInlineLink, {
                data: data,
                linkSize: linkSize,
                target: linkTarget,
                key: key
            });
            break;
        case "EGDSStylizedText":
            component = /* @__PURE__ */ React18.createElement(EGDSStylizedText, {
                data: data,
                size: textSize,
                key: key
            });
            break;
        case "PortableTextHTMLTableSection":
            component = /* @__PURE__ */ React18.createElement(TableSection, {
                data: data
            });
            break;
        default:
            component = null;
    }
    return spacing && component ? /* @__PURE__ */ React18.createElement(UitkSpacing2, {
        margin: {
            blockstart: blockstart || "three"
        }
    }, /* @__PURE__ */ React18.createElement("div", null, component)) : component;
};
// src/components/legal-content/__private/__fragments/portable-text-content.tsx
var fragment18 = gql18(_templateObject17(), EGDSPlainText.fragment, EGDSHeading.fragment, EGDSSpannableText.fragment, TableSection.fragment, EGDSInlineLink.fragment, EGDSStylizedText.fragment, LevelList.fragment);
var PortableTextContent = function(param) {
    var data = param.data;
    return legalText(data, {
        textSize: 400,
        spacing: true
    });
};
PortableTextContent.fragment = fragment18;
PortableTextContent.displayName = "PortableTextContent";
// src/components/legal-content/__private/__fragments/legal-document.tsx
var fragment19 = gql19(_templateObject18(), FileLink.fragment, PortableTextContent.fragment);
var LegalDocument = function(param) {
    var data = param.data, style = param.style;
    var fileLink = data.fileLink, portableTextContent = data.portableTextContent;
    return /* @__PURE__ */ React19.createElement(React19.Fragment, null, style !== "no-file" && fileLink && /* @__PURE__ */ React19.createElement(FileLink, {
        data: fileLink
    }), portableTextContent.map(function(element, index) {
        return /* @__PURE__ */ React19.createElement(PortableTextContent, {
            data: element,
            key: index
        });
    }));
};
LegalDocument.fragment = fragment19;
LegalDocument.displayName = "LegalDocument";
// src/components/legal-content/legal-content.tsx
var __Query = gql20(_templateObject19(), LegalDocument.fragment);
var LegalContent = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_style = props.style, style = _props_style === void 0 ? "default" : _props_style, loadingContent = props.loadingContent, onError = props.onError;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading && !data) {
        return loadingContent ? /* @__PURE__ */ React20.createElement(React20.Fragment, null, loadingContent) : null;
    }
    if (error || !data || !data.travelExperienceManagerContent.portableTextDocumentWithLink) {
        var _onError;
        (_onError = onError) === null || _onError === void 0 ? void 0 : _onError();
        return null;
    }
    return /* @__PURE__ */ React20.createElement(LegalDocument, {
        data: data.travelExperienceManagerContent.portableTextDocumentWithLink,
        style: style
    });
};
LegalContent.displayName = "sharedui-LegalContent";
export { LegalContent };
//# sourceMappingURL=index.js.map